module.exports = __webpack_public_path__ + "../static/img/nav-logo.9e8e0a2b.svg";